export function getFileInfo(input: File | Blob | string): {
  extension: string;
  contentType: string;
} {
  const defaultExtension = "bin";
  const defaultContentType = "application/octet-stream";

  const mimeMap: Record<string, { extension: string; contentType: string }> = {
    "image/jpeg": { extension: "jpg", contentType: "image/jpeg" },
    "image/png": { extension: "png", contentType: "image/png" },
    "image/gif": { extension: "gif", contentType: "image/gif" },
    "image/webp": { extension: "webp", contentType: "image/webp" },
    "video/mp4": { extension: "mp4", contentType: "video/mp4" },
    "video/webm": { extension: "webm", contentType: "video/webm" },
  };

  let extension: string | undefined;
  let contentType: string | undefined;

  if (typeof input === "string") {
    const base64Regex = /^data:([a-zA-Z0-9/+]+);base64,/;
    const base64Match = input.match(base64Regex);
    if (base64Match) {
      contentType = base64Match[1];
      extension = mimeMap[contentType]?.extension || defaultExtension;
      return {
        extension: extension || defaultExtension,
        contentType: contentType || defaultContentType,
      };
    }

    if (!input) {
      return { extension: defaultExtension, contentType: defaultContentType };
    }
    extension = input.split(".").pop()?.toLowerCase();
    if (!extension) {
      return { extension: defaultExtension, contentType: defaultContentType };
    }
    contentType =
      Object.values(mimeMap).find((item) => item.extension === extension)
        ?.contentType || defaultContentType;
  } else {
    if (input instanceof File && input.name) {
      extension = input.name.split(".").pop()?.toLowerCase();
    }
    if (!extension) {
      contentType = input.type || defaultContentType;
      extension = mimeMap[input.type]?.extension || defaultExtension;
    } else {
      contentType =
        Object.values(mimeMap).find((item) => item.extension === extension)
          ?.contentType || defaultContentType;
    }
  }

  return {
    extension: extension || defaultExtension,
    contentType: contentType || defaultContentType,
  };
}
